const getDaikinThermostatsList = (state) => state.daikinThermostatsList;

export default {
  getDaikinThermostatsList,
};
